export const HUNDRED_PERCENT = 100;
/** Max number of cells to use to render spaces */
export const DEFAULT_MAX_NUMBERS_OF_CELLS = 100;

export enum ColumnKeys {
  FloorNumber = 'floorNumber',
  FloorSpace = 'floorSpace',
  Spaces = 'spaces',
}

export enum BGColors {
  FloorColumn = 'FFD3D3D4',
  DefaultBG = 'FFE6E6E6',
  FillerBG = 'FFF6F6F6',
  FloorColumnHeader = 'FF005F45',
  SpacesHeader = 'FF009979',
  ElevatorBank = 'FF00A9D8',
}

export enum Colors {
  White = 'FFFFFFFF',
  FloorColumn = 'FFD3D3D4',
  DefaultText = 'FF565656',
  WhiteText = 'FFF0F0F0',
}

export const COLORS_BY_SCHEME = {
  Default: {
    'expire-12': 'FFD26666',
    'expire-24': 'FFE98365',
    'expire-36': 'FFFAA167',
    'expire-48': 'FFFFBE66',
    'expire-long': 'FF68C5A9',
    'expire-na': BGColors.DefaultBG,
    'brand-1': 'c46d69',
    'brand-2': 'db876c',
    'brand-3': 'eda470',
    'brand-4': 'f6c075',
    'brand-5': '7fc2bf',
    'brand-6': '81bbf5',
    'brand-7': '69a6a8',
    'brand-8': 'c29d7a',
    'brand-9': 'cc8981',
    'brand-10': '96a87f',
    'brand-11': '7792e6',
    'brand-12': '8499b2',
    'brand-13': '78adcc',
    'brand-14': 'b19ecb',
    'brand-15': 'cbb360',
    'brand-16': 'cb98cb',
    'agency-cbre': '006735',
    'agency-other': '8b5da7',
    'expire-1': 'd26666',
    'expire-2': 'e98365',
    'expire-3': 'faa167',
    'expire-4': 'ffbe65',
    'expire-5': '68c5a9',
    'expire-6': '538184',
    'expire-7': 'a488be',
    'expire-8': '874f74',
    'expire-beyond': '435254',
  },
  MediumVioletRed: {
    'expire-12': 'FF820052',
    'expire-24': 'FFa60068',
    'expire-36': 'FFc71585',
    'expire-48': 'FFce3a97',
    'expire-long': 'FFdb61ad',
    'expire-na': BGColors.DefaultBG,
  },
  CBREGreen: {
    'expire-12': 'FF006735',
    'expire-24': 'FF008445',
    'expire-36': 'FF00a657',
    'expire-48': 'FF23b46e',
    'expire-long': 'FF46c186',
    'expire-na': BGColors.DefaultBG,
  },
  RoyalBlue: {
    'expire-12': 'FF032b4f',
    'expire-24': 'FF073b6a',
    'expire-36': 'FF0f4c81',
    'expire-48': 'FF226199',
    'expire-long': 'FF3f74a3',
    'expire-na': BGColors.DefaultBG,
  },
  SlateGray: {
    'expire-12': 'FF374f66',
    'expire-24': 'FF51667a',
    'expire-36': 'FF708090',
    'expire-48': 'FF7d8b9a',
    'expire-long': 'FF95a0aa',
    'expire-na': BGColors.DefaultBG,
  },
};
